import Mask from '../../../components/Mask';
import { inject, observer } from 'mobx-react';
import defaultAvatar from '@/assets/images/simulation/default_avatar.png';
import styles from './RoleIntroduce.module.scss';
import MyIcon from '@/components/MyIcon';
const RoleIntroduceModal = (props) => {
    const { onClose, show } = props;
    let { simulation } = props.store;
    let { character = { other_roles: [] }, goal, rules } = simulation;
    return (
        <>
            <Mask show={show}>
                <div className={styles.boxWrap}>
                    <div className={styles.container}>
                        {/* 角色信息区域 */}
                        <div className={styles.roleInfoSection}>
                            <div className={styles.avatarContainer}>
                                <div className={styles.avatar}>
                                    {/* 实际项目中替换为真实头像 */}
                                    <img src={character.avatar || defaultAvatar} alt={character.name} />
                                </div>
                                <div className={styles.roleName}>
                                    <span className={styles.roleLabel}>【你】：{character?.name}</span>
                                    <span className={styles.roleText}>{character.role}</span>
                                    <span onClick={onClose} className={styles.closeIcon}>
                                        <MyIcon type="icon-a-guanbi31" />
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* 角色卡片区域 */}
                        <div className={styles.roleCardsSection}>
                            <div className={styles.roleCardsContainer}>
                                {character?.other_roles &&
                                    character?.other_roles.map((role, index) => (
                                        <div key={index} className={styles.roleCard}>
                                            <div className={styles.roleCardName}>{role.name}</div>
                                            <div className={styles.roleCardDescription}>{role.intro}</div>
                                        </div>
                                    ))}
                            </div>
                        </div>

                        <div className={styles.sectionWrap}>
                            {/* 目标区域 */}
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>【目标】</div>
                                <div className={styles.sectionContent}>{goal?.description}</div>
                            </div>
                            <div className={styles.splitLine}></div>
                            {/* 行为约束规则区域 */}
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>【行为约束规则】</div>
                                <ul className={styles.rulesList}>
                                    {rules.map((rule, index) => (
                                        <li key={index} className={styles.ruleItem}>
                                            {rule}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Mask>
        </>
    );
};

export default inject('store')(observer(RoleIntroduceModal));
